import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../utils/api";
import { buildImageUrl } from "../utils/imageUtils";
import { QUERY_KEYS } from "./usePrefetchStoreData";

export type Category = {
  id: number;
  is_deleted: string | null;
  deleted_by_cascade: boolean;
  created_at: string;
  updated_at: string;
  name: string;
  description: string;
  image: string | null;
};

type PaginatedCategoryResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: Category[];
};

export function useCategories() {
  return useQuery<Category[]>({
    queryKey: QUERY_KEYS.categories,
    queryFn: async () => {
      const data = await fetcher<PaginatedCategoryResponse | Category[]>(
        "/store/categories/?page_limit=100"
      );

      const categories = Array.isArray((data as any).results)
        ? (data as PaginatedCategoryResponse).results
        : (data as Category[]);

      const categoriesWithFixedImages = categories.map((category) => ({
        ...category,
        image: buildImageUrl(category.image),
      }));

      return categoriesWithFixedImages;
    },
    staleTime: 0,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: "always",
  });
}
